export default
{
    auth: {
      clientId: '02b62b67-0d6a-4725-8afb-e902a464baf3',
      authority:
        'https://login.microsoftonline.com/0b1b29b6-bff5-466c-819d-d389233b6719',
    },
    cache: {
      cacheLocation: 'localStorage',
    },
  }